import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError } from 'rxjs';
import { CognitoService } from './cognito.service';
import { GlobalService } from './global.service';

export const httpErrorInterceptor: HttpInterceptorFn = (req, next) => {
  let router = inject(Router);
  let cognitoService = inject(CognitoService);
  let globalService = inject(GlobalService);
  return next(req).pipe(
    catchError((err: HttpErrorResponse) => {
      console.log(err);
      if (err.status == 401) {
        globalService.setAlertMessage(
          'Your session has expired. Please log in again.'
        );
        cognitoService.signOut();
        setTimeout(() => router.navigateByUrl('/'), 3000);
      } else if (err.status == 403) {
        globalService.setAlertMessage(
          'You do not have permission to perform this action.'
        );
      } else {
        globalService.setAlertMessage(
          `An error occurred. Please try again later. Error: ${err.status} - ${err.statusText}`
        );
      }
      throw err;
    })
  );
};
